<template>
    <div>
        <!-- 物流軌跡弹窗 -->
        <el-dialog
          :visible.sync="trackingNumberVisible"
          width="800px"
          :before-close="trackingNumberClose"
          title="Logistics tracking information">
            <div style="max-height: 70vh;overflow-y: scroll;">
              <div class="content" v-if="typeLastLine.number">
                <h3>Tracking No. : {{ typeLastLine.number }}</h3>
                <h3 style="margin-bottom: 16px">Last Carrier : {{ typeLastLine.carrier_en }}</h3>
                <template v-if="typeLastLine.events.length">
                  <div class="timeline">
                    <div class="timeline_item f" v-for="(item, index) in typeLastLine.events" :key="index" >
                      <div class="time">{{item.time_iso | timeHandle}}</div>
                      <div class="dot p-r" :class="{dot_active: index === 0}">
                        <div class="solidLine"></div>
                      </div>
                      <div class="description" :class="{active: index === 0}">{{ item.description }}</div>
                    </div>
                  </div>
                </template>
                <emptyShow v-else></emptyShow>
              </div>
              <div class="content" v-if="typeFirstLine.number">
                <h3>Tracking No. : {{ typeFirstLine.number }}</h3>
                <h3 style="margin-bottom: 16px">First Carrier : {{ typeFirstLine.carrier_en }}</h3>
                <template v-if="typeFirstLine.events.length">
                  <div class="timeline">
                    <div class="timeline_item f" v-for="(item, index) in typeFirstLine.events" :key="index" >
                      <div class="time">{{item.time_iso | timeHandle}}</div>
                      <div class="dot p-r" :class="{dot_active: index === 0 && !typeLastLine.type}">
                        <div class="solidLine"></div>
                      </div>
                      <div class="description" :class="{active: index === 0 && !typeLastLine.type}">{{ item.description }}</div>
                    </div>
                  </div>
                </template>
                <emptyShow v-else></emptyShow>
              </div>
              <emptyShow v-if="!typeLastLine.number && !typeFirstLine.number"></emptyShow>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import API from '@/api'
import moment from 'moment'
import emptyShow from './emptyLogistics.vue'
export default {
  components: {
    emptyShow
  },
  filters: {
    timeHandle(value) {
      return moment(value).format('YYYY-MM-DD HH:mm')
    }
  },
  data() {
    return {
      trackingNumberVisible: false,
      trackingTimeLine: [],
      trackingNumberInfo: {
        trackingNumber: undefined,
        carrierCode: undefined
      }
    }
  },
  computed: {
    // 头程物流
    typeFirstLine() {
      const target = this.trackingTimeLine.find(e => e.type === 1)
      return target || { events: [] }
    },
    // 尾程物流
    typeLastLine() {
      const target = this.trackingTimeLine.find(e => e.type === 2)
      return target || { events: [] }
    }
  },
  methods: {
    show(item) {
      const params = {
        package_number: [item.omsPackId]
      }
      API.orderLogisticsTrackInfo(params).then(res => {
        this.trackingTimeLine = res.data
        this.trackingNumberVisible = true
        this.setSolidLineHeight()
      }).catch(err => {
        this.$message.error(err.data.message)
      })
    },
    trackingNumberClose() {
      this.trackingNumberInfo = {}
      this.trackingTimeLine = []
      this.trackingNumberVisible = false
    },
    setSolidLineHeight() {
      this.$nextTick(() => {
        // 每行连接实线基础高为36px，每多一行加22px
        const eleArr = document.querySelectorAll('.timeline_item');
        [...eleArr].forEach(e => {
          const clientHeight = e.children[2].clientHeight
          const dotEle = e.children[1]
          let descriptionLine = (clientHeight / 22)
          dotEle.children[0].style.height = `${36 + (descriptionLine - 1) * 22}px`
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.van-popup {
    width: 100%;
}
.content{
  margin-bottom: 30px;
  >h3{
    line-height: 26px;
  }
  .timeline {
    .timeline_item{
      margin-bottom: 24px;
      .time{
        font-size: 14px;
        line-height: 22px;
      }
      .dot{
        margin: 5px 8px 0 10px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #F5F7F7;
        border: 1px solid #CDD4DD;
        .solidLine {
          width: 2px;
          background-color: #CDD4DD;
          position: absolute;
          top: 10px;
          left: 4px;
          right: 0;
        }
      }
      .description {
        font-size: 14px;
        line-height: 22px;
        width: 350px;
      }
      .active{
        color: #99C41C;
      }
      .dot_active{
        background-color: #99C41C;
        border-color: #99C41C;
      }
    }
    .timeline_item:last-of-type{
      .dot{
        .solidLine{
          display: none;
        }
      }
    }

  }
}
</style>
